// src/shared/Utils.js
export function classNames(...classes) {
    return classes.filter(Boolean).join(" ");
  }